/**
 * Tracks the site header's rendered height with a ResizeObserver and writes it
 * to the `--site-header-height` custom property on :root, so any element on
 * the page can consume it.
 *
 * Usage:
 *   <header x-data="siteHeaderHeight">
 */

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'siteHeaderHeight', () => ({

		observer: null,

		init() {
			this.observer = new ResizeObserver( ( entries ) => {
				for ( const entry of entries ) {
					document.documentElement.style.setProperty(
						'--site-header-height',
						`${ entry.target.offsetHeight }px`
					);
				}
			});

			this.observer.observe( this.$el );

			this.$cleanup = () => this.observer.disconnect();
		},

	}) );
});
